import dayjs from "dayjs";

export const getInvoicePaymentStatus = ({
  totalOutstandingAmount,
  totalInvoiceAmount,
  paidAmount,
  statementPaymentDueDate,
  statementEndDate,
}: {
  totalOutstandingAmount: number;
  totalInvoiceAmount: number;
  paidAmount: number;
  statementPaymentDueDate: Date;
  statementEndDate: Date;
}) => {
  const today = dayjs();
  const afterDueDate = today.isAfter(dayjs(statementPaymentDueDate));
  const dueDatePlusFour = today.isAfter(
    dayjs(statementPaymentDueDate).add(4, "days"),
  );
  const afterEndDate = today.isAfter(dayjs(statementEndDate));
  if (dueDatePlusFour && totalOutstandingAmount > 0) return "Overdue";
  if (afterDueDate && totalOutstandingAmount > 0) return "Processing";
  if (paidAmount > 0 && totalOutstandingAmount > 0) return "Partially paid";
  if (totalInvoiceAmount > 0 && totalOutstandingAmount === 0) return "Paid";
  if (totalInvoiceAmount > 0 && totalOutstandingAmount > 0 && afterEndDate)
    return "Issued";
  return "Not yet issued";
};
